// SidebarLink.tsx or SidebarLink.jsx
import { NavLink, useLocation } from "react-router-dom";

const NavLinker = ({
  to,
  end = false,
  children,
  activeClassName = "flex flex-row bg-gray-500 p-2 rounded-md text-white gap-2 items-center",
  inactiveClassName = "flex flex-row hover:bg-gray-300 rounded-md p-2 gap-2 items-center",
}) => {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        isActive ? activeClassName : inactiveClassName
      }
    >
      {children}
    </NavLink>
  );
};

export default NavLinker;
